<template>
  <span>
    <VasionGeneralModal
      id="new-collection-dialog"
      modalType="slot"
      :modalTitle="'New Collection'"
      :sync="show"
      :hideButtons="false"
      :confirmButtonText="'Add'"
      :rejectButtonText="'Cancel'"
      :confirmButtonDisabled="collectionName.length === 0"
      showTopRightCloseButton
      @noButtonClick="close"
      @confirmButtonClick="collectionAdded"
    >
      <div>
        <VasionInput
          v-model="collectionName"
          class="input-style collection-name"
          inputType="top-white"
          :placeholder="'NewCollection'"
          :maxLengthProp="25"
          :regularExpression="'[a-zA-Z0-9_.\-]'"
          @input="errorLabelText = ''"
        />
        <label v-if="errorLabelText.length > 0" class="error-label">{{ errorLabelText }}</label>
      </div>
    </VasionGeneralModal>

    <VasionSnackbar
      :showSnackbarBool.sync="snackbar.show"
      :snackbarImage="snackbar.image"
      :snackbarSubTitle="snackbar.subtitle"
      :snackbarTitle="snackbar.title"
    />
  </span>
</template>

<script>
export default {
  name: 'AddCollectionModal',
  props: {
    awsId: {
      type: String,
      default: '',
      required: false,
    },
    awsSecret: {
      type: String,
      default: '',
      required: false,
    },
    awsRoleArn: {
      type: String,
      default: '',
      required: false,
    },
    awsRoleDuration: {
      type: Number,
      default: 3600,
      required: false,
    },
    awsRoleExternalId: {
      type: String,
      default: '',
      required: false,
    },
    authMethod: {
      type: String,
      default: 'keySecret',
      required: false,
    },
    id: {
      type: Number,
      default: 0,
      required: true,
    },
    region: {
      type: String,
      default: '',
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: function () {
    return {
      collectionName: '',
      errorLabelText: '',
      snackbar: {
        show: false,
        image: true,
        title: '',
        subtitle: ''
      }
    }
  },
  methods:{
    close(){
      this.collectionName = ''
      this.$emit('close')
    },
    showSnackbarSuccess(subtitle){
      this.snackbar = {
        title: 'Success',
        image: true,
        show: true,
        subtitle: subtitle
      }
    },
    async collectionAdded(){
      const payload = {
        id: this.id,
        awsRegion: this.region,
        collectionName: this.collectionName,
      }
      
      // Add auth-specific fields based on authMethod
      if (this.authMethod === 'keySecret') {
        payload.awsAccessKeyID = this.awsId
        payload.awsSecretKey = this.awsSecret
      } else {
        payload.awsRoleArn = this.awsRoleArn
        payload.awsRoleDuration = this.awsRoleDuration
        payload.awsRoleExternalId = this.awsRoleExternalId
      }

      const response = await this.$store.dispatch('admin/createRekognitionCollection', payload)
      if (response?.data?.Value?.length > 0 || response?.data?.ResultStatus === 2) {
        if (response.status === 400) {
          this.errorLabelText = "Collection name is not valid"  
        } else {
          this.errorLabelText = response.data.ResultMessage ?? 'Error saving collection.'
        }
        return
      }

      this.errorLabelText = ''
      this.showSnackbarSuccess(`'${this.departmentName}' added to collections`)

      this.$emit('collectionAdded', this.collectionName)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.collection-name {
  margin-top: 2rem;
  margin-bottom: 1rem;
  min-width: 350px;
}

.error-label {
  color: $error-red;
  font-weight: 200;
}
</style>
